import { Directive, InjectionToken } from '@angular/core';

/**
 * Injection token that can be used to reference instances of `MatSelectTrigger`. It serves as
 * alternative token to the actual `MatSelectTrigger` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const MAT_SELECT_TRIGGER = new InjectionToken<MatSelectTriggerDirective>('MatSelectTrigger');

/**
 * Allows the user to customize the trigger that is displayed when the select has a value.
 */
@Directive({
  selector: 'app-mat-select-trigger',
  providers: [{ provide: MAT_SELECT_TRIGGER, useExisting: MatSelectTriggerDirective }],
})
export class MatSelectTriggerDirective {}
